import * as moment from 'moment';

// UTC字符串格式化
// '2018-02-09T17:18:46:220000' => '2018-02-09'
export const dateFormat = (value: string, format = 'YYYY-MM-DD') => {
    if (!value) {
        return '';
    }
    return moment(value.slice(0, 19)).format(format);
}